/** 中央操作员在“设置 → 租户”中清除前的规划归档（第 2 阶段 P2-5）。 */
export default {
  archive: {
    title: '规划案件归档',
    intro: '清除会删除每个规划案件及其历史和文件。请先为每个案件创建归档包，连同公钥一起下载，并交给客户。',
    none: '该租户没有规划案件。',
    loading: '正在读取规划案件…',
    loadFailed: '无法读取规划案件。',
    retryLoad: '重试',
    counts: '{{cases}} 个案件中有 {{archived}} 个已有当前归档包。',
    liveJobs:
      '正在生成的包：{{exports}}。正在进行的图纸检查：{{intakes}}。正在进行的案件包导入：{{imports}}。正在生成的函件：{{letters}}。等待处理的任务：{{queued}}。',
    create: '创建归档包',
    retryFailed: '重试失败的包',
    stop: '停止',
    working: '正在创建归档包…',
    gapsTitle: '没有当前归档包的案件',
    gapsMore: '另有 {{count}} 个未列出。',
    reasons: {
      no_archive: '尚无归档包',
      stale: '归档包早于最近的更改',
      running: '正在生成',
      failed: '无法生成归档包',
      revoked: '由已吊销的密钥签封：将重新生成',
      chain_broken: '历史记录未通过验证：无法生成归档包',
    },
    packagesTitle: '归档包',
    packageLine: '截至事件 {{seq}}',
    download: '下载',
    downloadLabel: '下载 {{caseRef}} 的归档包',
    downloadFailed: '无法下载该归档包。',
    more: '显示更多归档包',
    jwks: '下载公钥（JWKS）',
    jwksHint: '清除会销毁签名密钥。没有此文件，之后任何人都无法验证这些归档包。',
    delivered: '我已将归档包和公钥交给客户。',
    waiver: '对所有 {{total}} 个没有当前归档包的案件不生成归档包即清除',
    waiverHint: '仅在案件无法归档，或客户已书面指示时使用。审计日志会记录此操作。',
    waiverReason: '原因',
    waiverReasons: {
      unarchivable: '这些案件无法归档',
      controller_instruction: '客户已指示',
    },
    blocked: {
      jobs_running: '请等待正在生成的包、图纸检查和案件包导入完成。',
      unarchived: '每个案件都需要当前归档包，或使用下面的豁免。',
      not_confirmed: '请确认已交付归档包。',
    },
    refusal: {
      planning_jobs_running:
        '清除被拒绝：仍有 {{exports}} 个包、{{intakes}} 项图纸检查、{{imports}} 项案件包导入和 {{letters}} 封函件生成正在进行，另有 {{queued}} 个任务在等待处理。',
      planning_cases_unarchived: '清除被拒绝：{{total}} 个案件没有当前归档包。',
      planning_archives_not_confirmed: '清除被拒绝：请确认已交付 {{archived}} 个归档包。',
      planning_register_unreachable:
        '清除被拒绝：规划登记服务器 {{host}}（{{database}}）无响应，因此无法删除该租户在其上的记录。请修复连接，或在不删除这些记录的情况下清除。',
    },
    registerSkip: '清除时不删除该租户在该登记服务器上的记录。这些记录将保留在服务器上；审计日志会记录此操作。',
    incomplete: '租户数据已删除，但仍有部分规划文件。请再次运行清除以完成。',
  },
}
